/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function () {
	class DashboardTheme {
		constructor() {
		}

		getAPI() {
			return this;
		}
	}
	return DashboardTheme;
});
